import React from 'react';
import SEO, { seoConfigs } from '../../common/SEO/SEO';

const PrivacyPage = () => (
    <>
    <SEO {...seoConfigs.privacy} />
    <div className="min-h-screen bg-gray-50 py-12">
        <div className="max-w-4xl mx-auto bg-white rounded-2xl shadow-lg p-8">
            <h1 className="text-3xl font-bold text-blue-600 mb-6">Aviso de Privacidad</h1>
            <p className="mb-4 text-gray-700">
                En MisTramites.mx, la protección de tus datos personales es muy importante para nosotros. Por favor, lee cuidadosamente este aviso de privacidad.
            </p>
            <h2 className="text-xl font-semibold text-blue-500 mt-6 mb-2">1. Responsable de los datos</h2>
            <p className="mb-4 text-gray-700">
                MisTramites.mx es responsable del tratamiento de tus datos personales.
            </p>
            <h2 className="text-xl font-semibold text-blue-500 mt-6 mb-2">2. Finalidad del tratamiento</h2>
            <p className="mb-4 text-gray-700">
                Tus datos serán utilizados para brindarte nuestros servicios, contactarte y mejorar tu experiencia en la plataforma.
            </p>
            <h2 className="text-xl font-semibold text-blue-500 mt-6 mb-2">3. Derechos ARCO</h2>
            <p className="mb-4 text-gray-700">
                Puedes acceder, rectificar, cancelar u oponerte al tratamiento de tus datos personales en cualquier momento enviando un correo a contacto@mistramites.mx.
            </p>
            <h2 className="text-xl font-semibold text-blue-500 mt-6 mb-2">4. Transferencia de datos</h2>
            <p className="mb-4 text-gray-700">
                Tus datos no serán compartidos con terceros sin tu consentimiento, salvo las excepciones previstas por la ley.
            </p>
            <h2 className="text-xl font-semibold text-blue-500 mt-6 mb-2">5. Cambios al aviso</h2>
            <p className="mb-4 text-gray-700">
                Este aviso puede ser modificado. Las actualizaciones estarán disponibles en esta página.
            </p>
            <div className="mt-8 text-xs text-gray-400">
                &copy; {new Date().getFullYear()} MisTramites.mx. Todos los derechos reservados.
            </div>
        </div>
    </div>
    </>
);

export default PrivacyPage;
